export default {"src":"/_next/static/media/backArrow.ecd79e7e.svg","height":21,"width":12};